export const testimonials = [
  {
    name: 'Dr. Sarah Jenkins',
    role: 'Family Physician · Ohio, USA',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/40ab19ac-4fbd-46fb-b5a4-7fa4ad9e3f5e.jpg',
    quote:
      'I finally stopped rebuilding my own checklists before every weight-related visit. The assessment worksheet alone gives my consultations a consistent structure from the first minute.',
  },
  {
    name: 'Dr. Michael Reeves',
    role: 'Internal Medicine · Texas, USA',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/d01147c9-dace-4704-8ac1-9cb8acb09ca2.jpg',
    quote:
      "What I value most is that it doesn't try to replace the guidelines. It simply organizes everything I already review — history, comorbidities, follow-up — in one place.",
  },
  {
    name: 'Dr. Amara Okafor',
    role: 'Endocrinologist · London, UK',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/2707645b-3c13-4eb0-96aa-1c5e77c61796.jpg',
    quote:
      'The Treatment Review Tracker made my follow-up documentation far more consistent. My notes are cleaner and outstanding questions no longer slip through the cracks.',
  },
  {
    name: 'Raj Patel, NP',
    role: 'Nurse Practitioner · Toronto, Canada',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/2c2d2659-72fb-4b44-b66c-223c6fb4d3e2.jpg',
    quote:
      'For $27 it was an easy decision. I printed the Long-Term Care Checklist and now use it in every periodic review. It saves me real preparation time each week.',
  },
];
